import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchInvitations,
  fetchInvitationById,
  createInvitation,
  updateInvitation,
  deleteInvitation,
  publishInvitation,
  unpublishInvitation,
  updateInvitationImage,
  updateInvitationTemplate,
  updateInvitationQrCode,
  clearErrorState,
  clearSuccessState,
  updateFilters,
  clearSelectedInvitation,
} from "../../../app/slice/invitationSlice";

const useInvitation = () => {
  const dispatch = useDispatch();
  const { invitations, selectedInvitation, loading, error, success, filters } =
    useSelector((state) => state.invitations);

  const getInvitations = useCallback(
    (f) => dispatch(fetchInvitations(f)),
    [dispatch],
  );
  const getInvitationById = useCallback(
    (id) => dispatch(fetchInvitationById(id)),
    [dispatch],
  );

  const createNewInvitation = useCallback(
    (data) => dispatch(createInvitation(data)).unwrap(),
    [dispatch],
  );

  const updateExistingInvitation = useCallback(
    (id, data) => dispatch(updateInvitation({ id, data })).unwrap(),
    [dispatch],
  );

  const deleteExistingInvitation = useCallback(
    (id) => dispatch(deleteInvitation(id)).unwrap(),
    [dispatch],
  );

  const publishExistingInvitation = useCallback(
    (id) => dispatch(publishInvitation(id)).unwrap(),
    [dispatch],
  );

  const unpublishExistingInvitation = useCallback(
    (id) => dispatch(unpublishInvitation(id)).unwrap(),
    [dispatch],
  );

  const updateImage = useCallback(
    (id, imageKey, url) =>
      dispatch(updateInvitationImage({ id, imageKey, url })).unwrap(),
    [dispatch],
  );

  const updateTemplate = useCallback(
    (id, templateUpdates) =>
      dispatch(updateInvitationTemplate({ id, templateUpdates })).unwrap(),
    [dispatch],
  );

  const updateQrCode = useCallback(
    (id, qrCodeUrl) =>
      dispatch(updateInvitationQrCode({ id, qrCodeUrl })).unwrap(),
    [dispatch],
  );

  const clearErrorStateFn = useCallback(
    () => dispatch(clearErrorState()),
    [dispatch],
  );
  const clearSuccessStateFn = useCallback(
    () => dispatch(clearSuccessState()),
    [dispatch],
  );
  const updateFiltersFn = useCallback(
    (f) => dispatch(updateFilters(f)),
    [dispatch],
  );
  const clearSelected = useCallback(
    () => dispatch(clearSelectedInvitation()),
    [dispatch],
  );

  return {
    invitations,
    selectedInvitation,
    loading,
    error,
    success,
    filters,
    getInvitations,
    getInvitationById,
    createNewInvitation,
    updateExistingInvitation,
    deleteExistingInvitation,
    publishExistingInvitation,
    unpublishExistingInvitation,
    updateImage,
    updateTemplate,
    updateQrCode,
    clearErrorState: clearErrorStateFn,
    clearSuccessState: clearSuccessStateFn,
    updateFilters: updateFiltersFn,
    clearSelectedInvitation: clearSelected,
  };
};

export default useInvitation;
